import styled from 'styled-components';
var Clamp = /*#__PURE__*/styled.p.withConfig({
  componentId: "sc-45y0yk-0"
})(["\n  display: -webkit-box;\n  -webkit-line-clamp: ", ";\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  @media (max-width: 768px) {\n    display: block;\n  }\n"], function (props) {
  return props.clamp;
});
export default Clamp;